import {Component, DestroyRef, OnInit, inject} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {UtilService} from '../../services/util.service';

@Component({
  selector: 'app-terms-of-use',
  templateUrl: './terms-of-use.component.html',
  styleUrls: ['./terms-of-use.component.scss'],
  standalone: false
})

export class TermsOfUseComponent implements OnInit {
  private _utilService: UtilService = inject(UtilService);
  private _destroyRef: DestroyRef = inject(DestroyRef);

  public content: string = '';

  public ngOnInit(): void {
    this._utilService.getTermsOfUse()
      .pipe(takeUntilDestroyed(this._destroyRef))
      .subscribe((result) => {
        this.content = result;
      });
  }
}
